import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi hijo rechazaba el lápiz hace tres meses. Hoy traza la A solo. No lo puedo creer.',
    name: 'Gabriela M.',
    role: 'Mamá de niño con autismo',
    city: 'Buenos Aires'
  }, {
    quote: 'Llevaba dos años buscando material y armando fichas los domingos. Con este kit terminé con eso. Mis alumnos avanzan y yo llego al lunes descansada.',
    name: 'Romina T.',
    role: 'Maestra de apoyo',
    city: 'Córdoba'
  }, {
    quote: 'Lo que más me gustó es que las instrucciones son para mí, no solo para el niño. Sé exactamente qué decir y qué no decir en cada ficha.',
    name: 'Claudia P.',
    role: 'Acompañante Terapéutica',
    city: 'Rosario'
  }, {
    quote: 'En la reunión con el equipo pude mostrar el registro semanal y los diplomas. Por primera vez tenía evidencia concreta de los avances de mi alumno.',
    name: 'Natalia G.',
    role: 'Mamá y docente',
    city: 'Mendoza'
  }, {
    quote: 'El Protocolo CALMA de la guía para familias cambió completamente cómo reacciono cuando se frustra. Eso solo vale el precio del kit.',
    name: 'Verónica S.',
    role: 'Mamá de niña con autismo',
    city: 'Tucumán'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <h2 className="text-3xl md:text-4xl font-black text-[#111111] mb-4" data-id="element-232">
            LO QUE DICEN MAMÁS Y MAESTRAS QUE YA LO USAN
          </h2>
          <div className="w-24 h-1.5 bg-[#C4A7E7] mx-auto rounded-full" data-id="element-233"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-gray-50 rounded-3xl p-8 border border-gray-100 flex flex-col ${idx === 3 || idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-235">
              <div className="flex gap-1 mb-4" data-id="element-236">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#C4A7E7] text-[#C4A7E7]" data-id="element-237" />)}
              </div>
              <p className="text-lg text-[#111111] italic mb-6 flex-grow" data-id="element-238">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-239">
                <p className="font-bold text-[#C4A7E7]" data-id="element-240">{t.name}</p>
                <p className="text-sm text-gray-600" data-id="element-241">{t.role}</p>
                <p className="text-xs text-gray-400 mt-1 uppercase tracking-wider" data-id="element-242">
                  {t.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}